<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1I4Zdq/tc-custom/9798891557123.jpg?1728726136633" alt="This image is the cover for the book Amelia Teaches Manners"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Amelia Teaches Manners
      </h1>
      <p class="bookDescription body article font2">
        <p>Join Amelia, an adventurous baby elephant, on her extraordinary quest to teach manners to the world! Journey with her through land, river, sand, and sea as she encounters all sorts of creatures, eager to learn politeness from their tiny tutor.</p><p>Along her travels, Amelia makes wonderful new friends but longs for her beloved family back home. Determined to follow the rainbow’s path, she sets off for the African bush, but a perilous detour leaves her adrift at sea. Will Amelia’s newfound friends come to her rescue?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Sheila  L.  Rutter
      </h2>
      
      <p class="authorDescription body article"><p style='margin-top:0mm;margin-right:0mm;margin-bottom:0mm;margin-left:0mm;font-size:15px;font-family:"Calibri",sans-serif;'><span style='font-size:15px;font-family:"Times New Roman",serif;'>Sheila L. Rutter grew up on a horse farm in a small town in Michigan. She joined the United States Air Force when she was twenty years old. Sheila did her four-year tour in Texas, Okinawa, Japan, and Florida. She married, had three beautiful children, was widowed young, and, after a few years, remarried. Sheila has been writing poetry and short stories for many years, with her first poem published in 2002. <em>Time with Grandma: Fun Family History Workbook</em> in 2020. She has a degree in graphic design and photography. Sheila knows the importance of family and would like to help parents teach their children manners by keeping it fun and memorable. </span></p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley Publishers
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?1a954931